import * as types from "../constants/sessionConstants"

const initialState = {
    isLogin: false,
    idToken: null,
    idUser: null,
    idTeam: null,
    role: null,
}

export default function SessionReducer(state=initialState, action) {
    switch(action.type) {
        case types.LOGIN:
            return {
                ...state,
                isLogin: action.payload.isLogin,
                idToken: action.payload.idToken,
                idUser: action.payload.idUser,
                idTeam: action.payload.idTeam,
                role: action.payload.role,
            }
        case types.REFRESH_COGNITO_TOKEN:
            return {
                ...state,
                idToken: action.payload.idToken,
            }
        case types.LOGOUT:
            return initialState
        default:
            return state
    }
}